import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover, Form } from "react-bootstrap";
import "./annuitythowmuchcash.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { addCommas } from "../../helpers/helpers";
export const AnnuityHowMuchCash = (props) => {
  const { choose } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const detailsData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  const choosingPot =
    Object.keys(choose).length === 0
      ? detailsData?.monetaryChosenAmount
      : choose?.monetaryChosenAmount;
  const taxFreeCash = (choosingPot * sliderValue) / 100;
  const annuityValue = (choosingPot - taxFreeCash).toFixed(2);
  const handleBack = () => {
    props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
  };

  const handleSliderChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setSliderValue(percentage);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace("%", "");
    if (inputValue === "") {
      setSliderValue("0");
    } else {
      const percentage = parseFloat(inputValue);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 25) {
        setSliderValue(percentage);
      }
    }
  };

  useEffect(() => {
    updateSliderBackground(sliderValue);
  }, [sliderValue]);

  const updateSliderBackground = (value) => {
    const percentage = (value / 25) * 100;
    if (sliderRef.current) {
      sliderRef.current.style.background = `linear-gradient(to right, var(--blue-100) 0%, var(--blue-100) ${percentage}%, var(--white) ${percentage}%, var(--white) 100%)`;
    }
  };

  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE;
    let takeGuaranteedIncomeAnnuity = {
      cashWithdrawPerc: sliderValue,
      cashWithdrawAmount: parseFloat(taxFreeCash.toFixed(2)),
      cashout: parseFloat(annuityValue),
    };
    let payload = {
      currentStep,
      choiceCategory: { takeGuaranteedIncomeAnnuity },
    };
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE, payload);
  };

  return (
    <>
      <Card className="application-step">
        <Card.Body className="how-much-cash">
          <Row>
            <Col md={12} className="top-section">
              <h2 className="heading">How much cash would you like to take?</h2>
              <p>
                You can use upto <strong>25% tax-free</strong> cash here. For
                higher cash sums, please go back and select the mix and match
                option.
              </p>

              <Card className="bottom-bg-card">
                <Card.Body>
                  <Row className="bottom-card-content">
                    <Col md={6}>
                      <p>
                        {" "}
                        Let us know the tax-free cash lump sum you wish to take
                        (up to 25%) by entering the percentage or using the
                        slider. The remainder will be used to buy an annuity.
                      </p>
                      <p className="form-field-annuity taking-cash">
                        <span>Taking as cash</span>
                        <input
                          type="text"
                          className="input-text"
                          value={`${sliderValue}%`}
                          onChange={handleInputChange}
                          min="0"
                          max="100"
                        />
                      </p>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col md={8} className="text-left">
                          <p>Retiring with:</p>
                          <p>Of which tax-free cash:</p>
                          <p>Buying an annuity with:</p>
                        </Col>
                        <Col md={4} className="text-right bld p-0">
                          <p>{"£" + addCommas(choosingPot)}</p>
                          <p>
                            {"£" +
                              addCommas(
                                taxFreeCash.toFixed(2), // eslint-disable-line
                              )}
                          </p>
                          <p>
                            {"£" +
                              addCommas(
                                annuityValue //eslint-disable-line
                              )}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div>
                    <p className="slider-value">
                      <span className="static">0%</span>
                      <span className="static text-right">25%</span>
                    </p>
                    <Form.Range
                      ref={sliderRef}
                      value={sliderValue}
                      min="0"
                      max="25"
                      className="custom-slider"
                      onChange={handleSliderChange}
                    />
                  </div>
                  <div className=" m-42 d-flex align-items-center">
                    <div className="value-correct-date">
                      {" "}
                      Values correct as of {todayDate}
                    </div>

                    <OverlayTrigger
                      placement="left"
                      overlay={
                        <Popover
                          id="popover-contained"
                          className="tooltip-popover-section custom-popover"
                        >
                          <Popover.Body className="tooltip-popover-body-how-much-cash">
                            <p>
                              {" "}
                              All the values are estimates, based on the most
                              accurate information available. They include all
                              the contributions paid by you and your employer.
                            </p>
                            <p>
                              The value of your pension savings is based on
                              current financial conditions and is not
                              guaranteed. The amounts you receive may be higher
                              or lower than the amounts shown above. Payment of
                              your pension will be subject to TPT’s Trust Deed
                              and Rules, and regulatory requirements.
                            </p>{" "}
                          </Popover.Body>
                        </Popover>
                      }
                      flip={true}
                    >
                      <span className="textarea-tooltip">
                        <Icons iconname="tool-tip" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="button-container">
            <Col md={6}>
              {" "}
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />
            </Col>
            <Col md={6} className="text-end">
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default AnnuityHowMuchCash;
